import BaseRepository from '@/repositories/base/BaseRepository'

class ChengStarOrderService extends BaseRepository {
    // 权益概览
	benefitOverview(data: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/cheng-star-order/benefit-overview',
			data,
		})
	}

    // 可购买产品列表
	canPurchaseList() {
		return this.post<any>({
			url: '/ebk-dkb-api/cheng-star-order/can-purchase-list',
			data: {},
		})
	}

    // 已购买列表
	alreadyPurchaseList() {
		return this.post<any>({
			url: '/ebk-dkb-api/cheng-star-order/already-purchase-list',
			data: {},
		})
	}

	// 权益详情（层级数据：consumeReturn/cptChangeTicket/inflationGold/monthlyEarn/monthlySend/offlineBenefitList/redPacketExtend）
	benefitDetail(data: any) {
		return this.post<any>({
			url: '/ebk-dkb-api/cheng-star-order/benefit-detail',
			data,
		})
	}
}

export default ChengStarOrderService
